import { Pipe, PipeTransform } from '@angular/core';
import { StatesPluginService } from './states-plugin.service';

@Pipe({
    name: 'statespipe',
    standalone: false
})
export class StatesPipe implements PipeTransform {
  public states: any;

  constructor(private service: StatesPluginService) {
    this.states = this.service.getStates();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.states);
  }
}
